import clsx from 'clsx';
import React from 'react';
import { Monitor, Moon, Sun } from 'react-feather';

import { useThemeMode } from '@/hooks/useThemeMode';

type ThemePreference = 'light' | 'dark' | 'system';

const options: { value: ThemePreference; icon: typeof Sun; label: string }[] = [
  { value: 'light', icon: Sun, label: 'Light' },
  { value: 'dark', icon: Moon, label: 'Dark' },
  { value: 'system', icon: Monitor, label: 'System' },
];

export function ThemeToggle(): React.JSX.Element {
  const { theme, setTheme } = useThemeMode();

  return (
    <div className="flex items-center gap-4 px-16 py-8">
      <div className="flex w-full rounded-md border border-surface-border bg-surface-elevated p-2">
        {options.map(({ value, icon: Icon, label }) => (
          <button
            key={value}
            type="button"
            onClick={() => setTheme(value)}
            className={clsx(
              'flex flex-1 items-center justify-center gap-4 rounded-sm px-8 py-4 text-12 font-medium transition-colors duration-100',
              theme === value
                ? 'bg-brand-primary text-white dark:bg-brand-light dark:text-brand-primary'
                : 'text-on-surface-secondary hover:text-on-surface'
            )}
            aria-label={`${label} theme`}
          >
            <Icon size={14} />
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default ThemeToggle;
